module.exports = __webpack_public_path__ + "img/180523_Keyvisual_seite.c7b605dc.jpg";